<template>
  <div ref="name">
    <div class="content_box">
      <!-- 内容一 -->
      <el-row>
        <!-- <el-col :span="12" style="margin-right: 10px">
          <div class="grid-content bg-purple multiple">
            <div class="model_navigation">
              <img src="../../assets/images-img/months.png" alt />
              <span class="span1">包月总数:</span>
              <span class="span2">
                <sup>{{ list.total_month }}</sup>
              </span>
            </div>
            <div class="model_navigation">
              <img src="../../assets/images-img/normal.png" alt />
              <span class="span1">正常:</span>
              <span class="span2">
                <sup>{{ list.normal_count }}</sup>
              </span>
            </div>
            <div class="model_navigation">
              <img src="../../assets/images-img/ontrial.png" alt />
              <span class="span1">试用中:</span>
              <span class="span2">
                <sup>{{ list.try_count }}</sup>
              </span>
            </div>
            <div class="model_navigation">
              <img src="../../assets/images-img/expire.png" alt />
              <span class="span1">已到期:</span>
              <span class="span2">
                <sup>{{ list.overdue_count }}</sup>
              </span>
            </div>
          </div>
        </el-col> -->

        <el-col :span="12" :class="crityStyleEl_right_box ? 'el_right_box1' : 'el_right_box'">
          <div style="display:flex">
            <div class="grid-content bg-purple">
              <span class="status">网吧状态</span>
              <template>
                <el-select v-model="value" placeholder="全部" @change="selectState" style="width: 100px">
                  <el-option v-for="item in options" :key="item.value" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
                <!-- <input v-model="searchName" v-if="crityStyleEl_right_box" /> -->
              </template>
            </div>

            <div class="each_txt">
              <span class="search_txt" style="padding-left: 20px">搜索</span>
              <div class="search_box">
                <el-input v-model="searchName" placeholder="请输入要查询的网吧账号和名称" class="el_input_style"></el-input>
                <!-- <input  v-model="searchName"  placeholder="请输入要查询的网吧账号和名称" class="el_input_style" > -->
                <!-- <input v-model="searchName" v-if="crityStyleEl_right_box" /> -->
                <el-button type="goon" icon="el-icon-search" style="margin-left: 20px"
                  @click="searchQuery()"></el-button>
                <!-- <div class="search" @click="searchQuery()">
                <img src="../../assets/images-img/echar.png" alt />
              </div> -->
              </div>
            </div>
          </div>
          <div v-if="bardeployclientshow">
            <router-link :to="'/newInternetBar'">
              <el-button type="goon" style="margin-left: 20px" size="medium">
                <i class="el-icon-circle-plus"></i>&nbsp; 新建网吧
              </el-button>
            </router-link>
            <!-- <el-button style="margin-left: 20px" type="goon" size="medium"
              ><a :href="bardeployclienturlzip">部署包月客户端.zip</a>
            </el-button> -->
            <!-- <a :href="bardeployclienturlexe"><el-button style="margin-left: 20px" type="goon" size="medium"
              >部署包月通用包
            </el-button></a>
            <div style="color:#F56C6C;font-size:14px;width:600px;float:right;margin-left:20px">
              包月版安装说明：先下载包月通用包，然后下载相应网吧的配置文件，将包月通用包和配置文件放在同目录下，网吧服务器将luancher启动程序下发至客户机快捷方式即可，无需做开机启动。
            </div> -->
          </div>
        </el-col>
      </el-row>

      <!-- 内容二 -->
      <div class="table_conent">
        <template>
          <div class="table_title">网吧管理列表</div>

          <el-table class="tableBox" style="height: 100%" :header-cell-style="{
          background: '#F1F6F9',
          color: '#606266',
          width: '100%',
        }" :data="tableData" border>
            <!-- agent_name -->
            <el-table-column label="代理昵称" width align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.agent_name }}</span>
              </template>
            </el-table-column>
            <el-table-column label="网吧名称" width align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.Name }}</span>
              </template>
            </el-table-column>

            <el-table-column label="终端机器数量" width align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.count }}</span>
              </template>
            </el-table-column>
            <el-table-column label="终端月单价(元)" width align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.price }}</span>
              </template>
            </el-table-column>
            <el-table-column label="在线终端数" width align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.bar_online_count }}</span>
              </template>
            </el-table-column>
            <el-table-column label="付费月数" width align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.charge_month }}</span>
              </template>
            </el-table-column>
            <el-table-column label="网吧状态" width align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.status }}</span>
              </template>
            </el-table-column>
            <el-table-column label="到期时间" width align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.overtime }}</span>
              </template>
            </el-table-column>
            <el-table-column label="网吧密钥" width align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.net_bar_id }}</span>
              </template>
            </el-table-column>

            <!-- <el-table-column label="区域信息" width align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.county.split("-")[1] }}</span>
              </template>
            </el-table-column> -->

            <!-- <el-table-column label="备注信息" width align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.bar_remark }}</span>
              </template>
            </el-table-column> -->

            <el-table-column label="网吧类型" width align="center">
              <template slot-scope="scope">
                <el-switch :value="scope.row.ip_switch" :active-value="1" :inactive-value="0" active-color="#13ce66" active-text="动态" inactive-text="静态"
                  @change="switchChange(scope.row)" inactive-color="#13ce66"></el-switch>
              </template>
            </el-table-column>

            <el-table-column label="操作" align="center" width="400">
              <template slot-scope="scope">
                <!-- agent_type -->
                <el-button style="margin-bottom: 5px;" v-if="agent_type == '管理员'" type="primary" plain size="mini"
                  class="table_btn" @click="rename_bar_name(scope.row)">修改网吧名称</el-button>
                <el-button v-if="agent_type == '管理员'" type="primary" plain size="mini" class="table_btn"
                  @click="add_set_number(scope.row)">增减台数</el-button>
                <el-button v-if="agent_type == '管理员'" type="primary" plain size="mini" class="table_btn"
                  @click="add_bar_timeclick(scope.row)">增减时长</el-button>
                <el-button type="primary" plain size="mini" class="table_btn"
                  @click="rechargeWay(scope.row)">充值</el-button>
                  <el-button v-if="agent_type != '管理员' && scope.row.ip_switch == 0" type="primary" plain size="mini" class="table_btn"
                  @click="open_add_ip_list(scope.row)">增加静态IP</el-button>
                <el-button v-if="agent_type != '管理员' && scope.row.ip_switch == 0" type="primary" size="mini" class="table_btn"
                  @click="download_profile(scope.row)">下载配置文件</el-button>
                <!-- <el-button
                  type="primary"
                  plain
                  size="mini"
                  class="table_btn"
                  @click="editDialog(scope.row)"
                >编辑</el-button>-->
                <!-- <el-button
                  v-if="agent_type =='区域经理' || agent_type =='管理员'"
                  type="warning"
                  plain
                  size="mini"
                  class="table_btn"
                  @click="modifyAdder(scope.row)"
                >修改</el-button> -->
                <!-- <el-button
                  type="success"
                  plain
                  size="mini"
                  class="table_btn"
                  @click="internetBarDialog(scope.row)"
                  >IP绑定</el-button
                > -->

                <el-button type="danger" plain size="mini" class="table_btn"
                  @click="delinternetBar(scope.row.net_bar_id)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </div>

      <!-- 修改弹出框 -->
      <el-dialog :visible.sync="modifyVisible" title="修改代理区域" width="30%" center>
        <div>
          <div class="search_box">
            <el-input v-model="parme.params.name" placeholder="请输入代理区域" class="el_input_style"></el-input>
            <div class="search" @click="searchModifyAdder()">
              <img src="../../assets/images-img/echar.png" alt />
            </div>
            <div class="positionl">
              <div v-for="(item, index) in addressTitle" :key="index">
                {{ item.pid_name }}>>
                <span :class="statusClsaa == index ? 'span1' : ''" @click="districtAndCounty(item, index)">{{ item.name
                  }}</span>
              </div>
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer" :center="false">
          <el-button type="primary" @click="getModifyAdder()">确 定</el-button>
          <el-button @click="cancelModifyAdder()">取 消</el-button>
        </span>
      </el-dialog>

      <!-- 充值弹窗 -->
      <el-dialog :visible.sync="recharge" title="充值" width="30%" center>
        <div class>
          <div class="visible_conent">
            <el-form ref="form" :model="form" label-width="80px" class="demo-ruleForm">
              <!-- <el-form-item label="网吧名称">
                <el-input v-model="form.name" placeholder="请输入网吧名称"></el-input>
              </el-form-item>-->
              <el-form-item label="单价(元)">
                <el-input v-model="parmasRecharge.money" :value="parmasRecharge.money"
                  :placeholder="parmasRecharge.money" disabled></el-input>
              </el-form-item>
              <el-form-item label="终端数量" class="visible_conent_minimum">
                <el-input v-model="parmasRecharge.bar_count" placeholder :value="parmasRecharge.bar_count"
                  :disabled="disabledState" @input="barCount"></el-input>

                <span class="minimum" v-if="!disabledState">(最低10台起)</span>
                <el-button type="success" icon="el-icon-edit" size="small" class="el_but" v-else
                  @click="inputCanEdit()">修改</el-button>
              </el-form-item>

              <el-form-item label="充值时长" :rules="[{ required: true }]">
                <el-select v-model="rechargeDuration" placeholder="请选择" @change="TimeChange($event)">
                  <el-option :key="item.id" :label="item.name" :value="item.id" v-for="item in terminal"></el-option>
                  <!-- <el-option label="区域二" value="beijing"></el-option> -->
                </el-select>
              </el-form-item>
              <el-form-item label="支付金额" class="visible_conent_price">
                <el-input v-model="paymentAmount" placeholder="0" disabled></el-input>
                <span class="price">元</span>
              </el-form-item>

              <el-form-item label="支付方式">
                <el-radio-group v-model="parmasRecharge.pay_way">
                  <el-radio label="2">微信</el-radio>
                  <el-radio label="1">支付宝</el-radio>
                </el-radio-group>
              </el-form-item>

              <el-form-item label="余额支付" v-if="moneyRemain != '' || moneyRemain != 0">
                <el-switch style="display: block; margin-top: 10px" v-model="onChangStatusSwidch" active-color="#13ce66"
                  inactive-color="#ff4949" active-text="是" inactive-text="否" @change="onChang"></el-switch>
              </el-form-item>
              <div class="moneryClass">
                余额：
                <span>{{ moneyRemain }}</span>元 <span>{{ deductionText }}</span>
              </div>
            </el-form>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="rechargeDetermine()">确 定</el-button>
          <el-button @click="rechargeCancel()">取 消</el-button>
        </span>
      </el-dialog>

      <!-- 二维码弹出层 -->
      <el-dialog :visible.sync="textQrCodeUrl" width="30%" center title="扫码充值" :before-close="disgraceful">
        <div class="qrCodeBox">
          <!-- <div class="el-dialog__headerbtn" @click="cancelDialog()">
            <i class="el-dialog__close el-icon el-icon-close"></i>
          </div> -->
          <div v-if="overtimeState == ''">
            <!-- <div class="scanQecharge">扫码充值</div> -->
            <div class="amount">订单金额：￥{{ rechargeData.amount }}</div>
            <div class="Recharge">充值时长：{{ rechargeData.time }}个月</div>
            <div ref="qrCodeUrl" id="qrcodeImg" style="display: inline-block"></div>
            <div class="foorter"></div>
            <div class="orderNumber">订单号：{{ rechargeData.ordersn }}</div>
          </div>
          <!-- <div v-else>{{overtimeState}}</div> -->
          <div v-else>
            <div class="scanQecharge">扫码充值</div>
            <div class="timeOver">{{ overtimeState }}</div>
          </div>
        </div>
      </el-dialog>
      <!-- 编辑弹窗 -->
      <!-- <el-dialog title="编辑" :visible.sync="editDialogVisible" width="30%" center>
        <el-form>
          <el-form-item label="网吧名称">
            <el-input v-model="edit.name" disabled></el-input>
          </el-form-item>
          <el-form-item label="终端包月单价(元)">
            <el-input v-model="edit.price" disabled></el-input>
          </el-form-item>
          <el-form-item label="备注信息">
            <el-input type="textarea" v-model="edit.remarks" placeholder="备注的相关信息"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="editDialogCancel()">确 定</el-button>
          <el-button @click="editDialogRecharge()">取 消</el-button>
        </span>
      </el-dialog>-->

      <el-dialog title="网吧名字修改" :visible.sync="rename_bar_timeshow" width="30%" center class="inter_box">
        <div style="display:flex">
          <p style="line-height:40px;margin-right:62px">新名字：</p>
          <el-input v-model="rename_bar.name" style="width:60%" placeholder="输入新名字"></el-input>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="rename_bar_time_canceltrue()">确 定</el-button>
          <el-button @click="rename_bar_time_cancel()">取 消</el-button>
        </span>
      </el-dialog>
      <el-dialog title="网吧时长增减" :visible.sync="add_bar_timeshow" width="30%" center class="inter_box">
        <div style="display:flex; margin-bottom: 20px;">
          <p style="line-height:40px;margin-right:20px">请选择到期时间：</p>
          <el-date-picker :clearable="false" v-model="add_bar_timefrom.day" type="date" placeholder="选择日期"
            format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
        </div>
        <div style="display:flex">
          <p style="line-height:40px;margin-right:62px">增加理由：</p>
          <el-input v-model="add_bar_timefrom.remark" style="width:60%" placeholder="输入增加理由"></el-input>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="add_bar_time_canceltrue()">确 定</el-button>
          <el-button @click="add_bar_time_cancel()">取 消</el-button>
        </span>
      </el-dialog>
      <el-dialog title="网吧台数增减" :visible.sync="set_number_show" width="30%" center class="inter_box">
        <div style="display:flex; margin-bottom: 20px;">
          <p style="line-height:40px;margin-right:20px">请输入台数：</p>
          <el-input v-model="set_numberform.num" style="width:60%" placeholder="输入多少台就更新为多少台，数字"></el-input>
        </div>
        <div style="display:flex">
          <p style="line-height:40px;margin-right:34px">增加理由：</p>
          <el-input v-model="set_numberform.remark" style="width:60%" placeholder="输入增加理由"></el-input>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="set_numbertrue()">确 定</el-button>
          <el-button @click="() => { this.set_number_show = false }">取 消</el-button>
        </span>
      </el-dialog>
      <!-- 网吧绑定 -->
      <el-dialog title="网吧绑定" :visible.sync="internetBarDialogVisible" width="30%" center class="inter_box">
        <el-form style="text-align: center; color: red">
          <el-form-item label="网吧Ip1">
            <el-input v-model="bar.ip_list1" placeholder="请输入合法的ip"></el-input>
          </el-form-item>
          <el-form-item label="网吧Ip2">
            <el-input v-model="bar.ip_list2" placeholder="请输入合法的ip"></el-input>
          </el-form-item>
          <el-form-item label="网吧Ip3">
            <el-input v-model="bar.ip_list3" placeholder="请输入合法的ip"></el-input>
          </el-form-item>
          <!-- <span v-if="disStatus.length == 3">网吧ip已满</span> -->
        </el-form>

        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="internetBarDialogCancel()">确 定</el-button>
          <el-button @click="internetBarDialogRecharge()">取 消</el-button>
        </span>
        <!-- <div
          class="footer_ip dialog-footer"
          slot="footer"
          style="
            height: 30px;
            margin-top: 20px;
            text-align: bottom;
            border-top: 1px solid #dbe4ee;
            line-height: 30px;
            color: #8aa2c3;
            padding-top: 20px;
          "
        > -->
        <!-- <span class="dialog-footer" slot="footer">已绑定IP：{{ip_list}}</span> -->
        <!-- </div> -->
      </el-dialog>

      <el-dialog title="增加静态ip" :visible.sync="add_ip_list_show" width="30%" center class="inter_box">
        <span slot="footer" class="dialog-footer">
          <div style="margin-bottom: 20px; text-align: left; font-size: 14px; color: #ec0808">IP不能重复</div>
          <div style="margin-bottom: 10px;"><el-input v-model="ipAress.barIp1" placeholder="请输入合法IP1" clearable></el-input></div>
          <div style="margin-bottom: 10px;"><el-input v-model="ipAress.barIp2" placeholder="请输入合法IP2" clearable></el-input></div>
          <div style="margin-bottom: 10px;"><el-input v-model="ipAress.barIp3" placeholder="请输入合法IP3" clearable></el-input></div>
          <div style="margin-bottom: 10px;"><el-input v-model="ipAress.barIp4" placeholder="请输入合法IP4" clearable></el-input></div>
          <div style="margin-bottom: 10px;"><el-input v-model="ipAress.barIp5" placeholder="请输入合法IP5" clearable></el-input></div>
          <el-button type="primary" @click="add_ip_list_req()">确 定</el-button>
          <el-button @click="add_ip_list_show = false">取 消</el-button>
        </span>
      </el-dialog>

      <div class="pagetion">
        <el-pagination background layout="prev, pager, next" :total="total_count"
          @current-change="handleCurrentChange"></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import {ipcheck} from "../../common/utils"
import * as sysApi from "../../common/sys";
import QRCode from "qrcodejs2";
export default {
  data() {
    return {
      ipAress: {
        barIp1: "", //网吧IP1
        barIp2: "", //网吧IP2
        barIp3: "", //网吧IP3
        barIp4: "", //网吧IP4
        barIp5: "" //网吧IP5
      },
      add_ip_list: {
        id: 0,
        ip_list: ""
      },
      add_ip_list_show: false,
      set_number_show: false,
      set_numberform: {
        id: "",
        num: "",
        remark: "",
      },
      add_bar_timefrom: {
        net_bar_id: "",
        day: "",
        remark: "",
      },
      add_bar_timeshow: false, //时长增减弹框
      rename_bar: {
        net_bar_id: "",
        name: "",
      },
      rename_bar_timeshow: false, //网吧名字弹框
      edit: {
        name: "",
        price: "",
        remarks: "",
      },
      bar: {
        ip_list1: "",
        ip_list2: "",
        ip_list3: "",
      },
      form: {
        form: "",
        resource: "",
        region: "",
      },
      // editDialogVisible: false,
      recharge: false,
      internetBarDialogVisible: false,
      options: [
        {
          value: 0,
          label: "全部",
        },
        {
          value: 1,
          label: "试用中",
        },
        {
          value: 2,
          label: "正常",
        },
        {
          value: 5,
          label: "三天到期",
        },
        {
          value: 6,
          label: "大于三天",
        },
        {
          value: 3,
          label: "已过期",
        },
        {
          value: 4,
          label: "未激活",
        },
      ],
      parme: {
        // 搜索区域
        params: {
          name: "", //
        },
      },
      duihuancount: 0,
      deductionText: "",
      netBarId: "", //选择区域的id
      addressTitle: [], //修改搜索数组
      statusClsaa: null, //修改弹出框样式
      modifyVisible: false, //修改弹出框状态
      value: "",
      searchName: "",
      tableData: [], //列表数据
      total_count: null,
      params: {
        bar_status: 0, // 0.全部 1.试用中 2.正常 3.已过期 4.未激活
        page: 1, // 默认一页 一页10条
        search: "", //  搜索
      },
      terminal: [
        { name: "1个月", id: 1 },
        { name: "2个月", id: 2 },
        { name: "3个月(赠送1个月)", id: 3 },
        { name: "6个月(赠送3个月)", id: 6 },
      ],
      rechargeDuration: "", //充值时长
      disabledState: true, //disabled状态
      paymentAmount: "",
      parmasRecharge: {
        money: 5,
        agent_id: "", // id
        bar_count: 0, //终端数量
        cyberbar_id: null, //网吧ID
        month: 1, // 几个月
        pay_way: "2", //支付方式  1是支付宝   2是微信
      },
      qrCodeRecharge: false, //二维码弹出框
      textQrCodeUrl: false,
      // 扫码充值
      rechargeData: {
        amount: "", //金额]
        ordersn: "", //订单号
        time: "", //几个月
      },
      parmas: {
        order_sn: "",
      },
      timer: null,
      flag: null,
      count: "",
      overtime: "",
      overtimeState: "",
      ip_list: "", //网吧列表
      net_bar_id: "", //网吧id
      list: {
        normal_count: "", // 正常
        overdue_count: "", // 已过期
        try_count: "", //  使用中
        total_month: "", //包月总数
      },
      timeStatus: null, // 定时器的时间
      timerEliminate: "",
      agent_type: "",
      switchValue: true, //动态网吧
      value2: true,
      moneyRemain: "", // 余额
      onChangStatusSwidch: false, //   开关的状态
      crityStyleEl_right_box: "",
      bardeployclientshow: true,
      bardeployclienturlzip: "",
      bardeployclienturlexe: "",
    };
  },

  created() {
    let type = localStorage.agent_type;
    this.agent_type = localStorage.agent_type;
    // this.moneyRemain = this.$store.state.moneyRemain; // 余额
    if (type == "管理员") {
      this.bardeployclientshow = false;
    } else {
      this.bardeployclientshow = true;
      this.getbarclienturl();
    }
    if (type == "一级代理") {
      this.parmasRecharge.money = localStorage.getItem("agent_money")
        ? localStorage.getItem("agent_money")
        : 5;
    } else if (type == "二级代理") {
      this.parmasRecharge.money = localStorage.getItem("agent_money")
        ? localStorage.getItem("agent_money")
        : 7;
    } else if (type == "三级代理") {
      this.parmasRecharge.money = localStorage.getItem("agent_money")
        ? localStorage.getItem("agent_money")
        : 8;
    }
    this.internetBarList();
    // this.barCountQuery();//顶部隐藏
    this.initMoney();

    if (this._isMobile()) {
      this.crityStyleEl_right_box = true;
    } else {
      this.crityStyleEl_right_box = false;
    }
  },
  destroyed() {
    clearInterval(this.timer);
  },
  methods: {
    //确认增减时长
    add_bar_time_canceltrue() {
      console.log(this.add_bar_timefrom);
      sysApi.add_bar_time(this.add_bar_timefrom).then((res) => {
        if (res.code == 1) {
          this.add_bar_timeshow = false;
          this.$message.success(res.result);
          this.internetBarList();
        }
      });
    },
    add_bar_time_cancel() {
      this.add_bar_timeshow = false;
    },

    set_numbertrue() {
      console.log(this.set_numberform);
      this.set_numberform.num = parseInt(this.set_numberform.num);
      sysApi.update_bar_num(this.set_numberform).then((res) => {
        if (res.code == 1) {
          this.set_number_show = false;
          this.$message.success(res.result);
          this.internetBarList();
        }
      });
    },
    //管理员增减台数
    add_set_number(row) {
      this.set_number_show = true;
      this.set_numberform.id = row.ID;
    },
    //管理员修改网吧名称
    rename_bar_name(row) {
      this.rename_bar_timeshow = true;
      this.rename_bar.net_bar_id = row.net_bar_id;
    },
    rename_bar_time_canceltrue() {
      sysApi.rename_bar(this.rename_bar).then((res) => {
        if (res.code == 1) {
          this.rename_bar_timeshow = false;
          this.rename_bar.name = "";
          this.$message.success(res.result);
          this.internetBarList();
        }
      });
    },
    rename_bar_time_cancel() {
      this.rename_bar_timeshow = false;
      this.rename_bar.name = "";
    },

    //管理员增减时长
    add_bar_timeclick(row) {
      console.log(row);
      this.add_bar_timeshow = true;
      this.add_bar_timefrom.day = row.overtime.split(" ")[0];
      this.add_bar_timefrom.net_bar_id = row.net_bar_id;
    },
    //网吧下载链接
    getbarclienturl() {
      let account_number = "account_number=" + localStorage.agent_number;
      this.$http2
        .post(this.$api.api.bar_downloads, account_number)
        .then((res) => {
          console.log(res);
          if (res.data.code != 1) {
            return this.$message.error(res.data.result);
          }
          // this.bardeployclienturlzip = res.data.result.by_zip_url;
          this.bardeployclienturlexe = res.data.result.file_url;
        });
    },
    // 判断是pc 还是手机端
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    // 显示余额
    initMoney() {
      this.$http3.get(this.$api.api.remain_money).then((res) => {
        console.log(res);
        if (res.data.code != 1) {
          return this.$message.error(res.data.result);
        }
        this.moneyRemain = res.data.result;
        if (this.moneyRemain > 0) {
          this.duihuancount = parseInt(
            this.moneyRemain / localStorage.getItem("agent_money")
          );
          if (this.duihuancount > 1) {
            this.deductionText =
              "（可兑换" + this.duihuancount + "台终端（一个月））";
          } else {
            this.deductionText = "";
          }
        } else {
          this.deductionText = "";
        }
      });
    },
    //  网吧数量信息
    barCountQuery() {
      this.$http.get(this.$api.api.bar_count).then((res) => {
        if (res.data.code != 1) {
          return this.$message.error(res.data.result);
        }

        this.list.normal_count = res.data.result.normal_count; // 正常
        this.list.overdue_count = res.data.result.overdue_count; // 已过期
        this.list.try_count = res.data.result.try_count; //  使用中
        this.list.total_month =
          res.data.result.normal_count +
          res.data.result.overdue_count +
          res.data.result.try_count; // 包月总数
      });
    },

    // 网吧列表
    internetBarList() {
      this.$http.post(this.$api.api.bar_list, this.params).then((res) => {
        if (res.data.code != 1) {
          return this.$message.error(res.data.result);
        }
        this.total_count = res.data.total_count;
        this.tableData = res.data.data;
      });
    },

    // 点击时长
    TimeChange(val) {
      if (val == 1) {
        this.parmasRecharge.month = val;
        this.paymentAmount =
          val *
          Number(this.parmasRecharge.money) *
          Number(this.parmasRecharge.bar_count);
      } else if (val == 2) {
        this.parmasRecharge.month = val;
        this.paymentAmount =
          val *
          Number(this.parmasRecharge.money) *
          Number(this.parmasRecharge.bar_count);
      } else if (val == 3) {
        this.parmasRecharge.month = val;
        this.paymentAmount =
          val *
          Number(this.parmasRecharge.money) *
          Number(this.parmasRecharge.bar_count);
      } else if (val == 6) {
        this.parmasRecharge.month = val;
        this.paymentAmount =
          val *
          Number(this.parmasRecharge.money) *
          Number(this.parmasRecharge.bar_count);
      } else {
        this.parmasRecharge.month = val;
        this.paymentAmount =
          val *
          Number(this.parmasRecharge.money) *
          Number(this.parmasRecharge.bar_count);
      }
    },
    open_add_ip_list(data) {
      this.add_ip_list_show = true;
      this.add_ip_list.id = data.ID;
      const ip_list = data.ip_list.split(",");
      for (let index = 0; index < ip_list.length; index++) {
        const element = ip_list[index];
        this.ipAress["barIp" + (index + 1)] = element;
      }
    },
    add_ip_list_req() {
      if (this.fromData()) {
        this.add_ip_list.ip_list = Object.values(this.ipAress).filter(ele => !!ele).join(",")
        
        this.$http.post(this.$api.api.add_bar_ip, this.add_ip_list).then(res => {
          console.log(res);
          if (res.data.code != 200) {
            return this.$message.error(res.data.msg);
          }
          this.add_ip_list_show = false;
          this.internetBarList();
          return this.$message.success(res.data.info);
        });
       
      }
    },
    fromData() {
      if (this.ipAress.barIp1.trim() == "") {
          this.$message.error("必须填写一个ip");
          return false;
      }
      if (this.ipAress.barIp1.trim() != ""&&!ipcheck(this.ipAress.barIp1)) {
        this.$message.error("请输入正确的ip1地址");
        return false;
      }
      if(this.ipAress.barIp2.trim() != ""&&!ipcheck(this.ipAress.barIp2)){
        this.$message.error("请输入正确的ip2地址");
        return false;
      }
      if(this.ipAress.barIp3.trim() != ""&&!ipcheck(this.ipAress.barIp3)){
        this.$message.error("请输入正确的ip3地址");
        return false;
      }
      if(this.ipAress.barIp4.trim() != ""&&!ipcheck(this.ipAress.barIp4)){
        this.$message.error("请输入正确的ip4地址");
        return false;
      }
      if(this.ipAress.barIp5.trim() != ""&&!ipcheck(this.ipAress.barIp5)){
        this.$message.error("请输入正确的ip5地址");
        return false;
      }
      return true;
    },
    // 改变网吧状态
    switchChange(data, val) {
      if (data.ip_switch === 1) {
        this.getSwith(data.net_bar_id, 0);
      } else {
        this.getSwith(data.net_bar_id, 1);
      }
    },
    //  改变网吧状态 方法
    getSwith(data, val) {
      let params = {
        status: val,
        net_bar_id: data,
      };
      this.$confirm("是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http.post(this.$api.api.update_run_bar, params).then((res) => {
            if (res.data.code != 1) {
              return this.$message.error(res.data.result);
            }
            this.internetBarList();
            return this.$message.success(res.data.result);
          });
        })
        .catch(() => {
        });
    },

    // input的值
    barCount() {
      this.TimeChange(this.rechargeDuration);
    },
    // 改变状态
    inputCanEdit() {
      this.disabledState = false;
    },
    // 弹出修改区域
    modifyAdder(data) {
      this.netBarId = data.net_bar_id;
      this.modifyVisible = true;
    },
    // 修改区域 选择样式
    districtAndCounty(data, val) {
      this.district = `${data.id}-${data.name}`;
      this.statusClsaa = val;
    },
    // 弹框框 取消按钮
    cancelModifyAdder() {
      this.modifyVisible = false;
      this.netBarId = "";
      this.district = "";
      this.parme.params.name = "";
      this.addressTitle = [];
      this.statusClsaa = null;
    },
    // 确定修改
    getModifyAdder() {
      if (!this.district) {
        return this.$message.error("请选择需要修改的区域");
      }
      let parme = { district: this.district, net_bar_id: this.netBarId };
      this.$http.post(this.$api.api.update_bar_district, parme).then((res) => {
        if (res.data.code != 1) {
          return this.$message.error(res.data.result);
        }
        this.modifyVisible = false;
        this.netBarId = "";
        this.district = "";
        this.parme.params.name = "";
        this.addressTitle = [];
        this.statusClsaa = null;
        this.internetBarList();
        this.$message.error(res.data.result);
      });
    },
    // 修改区域的搜索
    searchModifyAdder() {
      if (!this.parme.params.name) {
        return this.$message.error("请输入代理区域");
      }
      this.$http.get(this.$api.api.search_district, this.parme).then((res) => {
        if (res.data.code != 1) {
          return this.$message.error(res.data.result);
        } else if (res.data.result.length == 0) {
          this.$message.error("暂无代理区域！");
        } else {
          this.addressTitle = res.data.result;
        }
      });
    },

    twoStatus() {
      console.log(this.parmasRecharge);
      this.$http3
        .post(this.$api.api.create_order, this.parmasRecharge)
        .then((res) => {
          if (res.data.code != 1) {
            return this.$message.error(res.data.result);
          } else {
            this.recharge = false;
            this.textQrCodeUrl = true;
            this.$nextTick(function () {
              this.rechargeData.amount = res.data.data.amount;
              this.rechargeData.ordersn = res.data.data.ordersn;
              this.rechargeData.time = res.data.data.time;
              this.$store.commit("orderState", res.data.data.ordersn);
              this.parmas.order_sn = res.data.data.ordersn;
              this.$refs.qrCodeUrl.innerHTML = "";
              this.creatQrCode(res.data.data);

              let count = 0;
              let countTime = 1500;
              this.timerEliminate = setInterval(() => {
                count++;
                if (count == 10) {
                  countTime = 3000;
                }
                if (count == 50) {
                  countTime = 3500;
                }
                if (count == 100) {
                  countTime = 4000;
                }
                if (count == 180) {
                  clearInterval(this.timerEliminate);
                }
                this.stateOrder();
              }, countTime);
            });
            this.initMoney();
            return this.$message.success(res.data.result);
          }
        });
    },
    // 如果用余额的话 就调这个接口
    orderRemain(type) {
      console.log(this.parmasRecharge);
      if (type == 1) {
        // debugger;
        this.parmasRecharge.use_remain_money = this.paymentAmount;
        this.$http3
          .post(this.$api.api.remain_order, this.parmasRecharge)
          .then((res) => {
            console.log(res);
            if (res.data.code != 1) {
              return this.$message.success(res.data.result);
            }
            this.recharge = false;
            this.initMoney();
            this.internetBarList();
            return this.$message.success(res.data.result);
          });
      } else {
        this.$http3
          .post(this.$api.api.remain_order, this.parmasRecharge)
          .then((res) => {
            console.log(res);
            if (res.data.code != 1) {
              return this.$message.error(res.data.result);
            } else {
              this.recharge = false;
              this.textQrCodeUrl = true;
              this.$nextTick(function () {
                this.rechargeData.amount = res.data.data.amount;
                this.rechargeData.ordersn = res.data.data.ordersn;
                this.rechargeData.time = res.data.data.time;
                this.$store.commit("orderState", res.data.data.ordersn);
                this.parmas.order_sn = res.data.data.ordersn;
                this.$refs.qrCodeUrl.innerHTML = "";
                this.creatQrCode(res.data.data);
                let count = 0;
                let countTime = 1500;
                this.timerEliminate = setInterval(() => {
                  count++;
                  if (count == 10) {
                    countTime = 3000;
                  }
                  if (count == 50) {
                    countTime = 3500;
                  }
                  if (count == 100) {
                    countTime = 4000;
                  }
                  if (count == 180) {
                    clearInterval(this.timerEliminate);
                  }
                  this.stateOrder();
                }, countTime);
              });
              this.initMoney();
              return this.$message.success(res.data.result);
            }
          });
      }
    },
    // 充值确定两种情况  1是  开始余额支付      2是开启余额支付余额不足
    rechargeDetermine() {
      //  if(this.moneyRemain !='' || this.moneyRemain != 0){ }
      console.log(this.onChangStatusSwidch);
      if (this.rechargeDuration == "请选择") {
        return this.$message.error("请选择时长!");
      }
      this.parmasRecharge.pay_way = Number(this.parmasRecharge.pay_way);
      this.parmasRecharge.bar_count = Number(this.parmasRecharge.bar_count);
      if (this.onChangStatusSwidch) {
        if (this.moneyRemain >= this.paymentAmount) {
          this.orderRemain(1); // 余额支付
        } else {
          // this.parmasRecharge.use_remain_money = this.moneyRemain;
          this.parmasRecharge.use_remain_money =
            this.duihuancount * localStorage.getItem("agent_money");
          this.orderRemain(2); // 开启余额支付余额不足
        }
      } else {
        this.twoStatus(); // 不开启余额支付
      }
    },

    onChang(status) {
      this.onChangStatusSwidch = status;
    },

    // 生成二维码
    creatQrCode(val) {
      var qrcode = new QRCode(this.$refs.qrCodeUrl, {
        text: val.qrcode, // 需要转换为二维码的内容
        width: 200,
        height: 200,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H,
      });
    },
    //  订单状态
    stateOrder() {
      this.$http3.post(this.$api.api.status, this.parmas).then((res) => {
        if (res.data.code == 1) {
          clearInterval(this.timerEliminate);
          this.textQrCodeUrl = false;
          this.internetBarList();
          return this.$message.success(res.data.result);
        }
      });
    },

    disgraceful() {
      this.cancelDialog();
    },
    // 关闭充值
    cancelDialog() {
      this.textQrCodeUrl = false;
      clearInterval(this.timerEliminate);
    },

    // 分页
    handleCurrentChange(val) {
      this.params.page = val;
      this.internetBarList();
    },
    // 搜索
    searchQuery() {
      this.params.search = this.searchName;
      this.internetBarList();
    },
    // 更新网吧状态
    selectState(event) {
      console.log(event);
      this.params.bar_status = event;
      this.internetBarList();
    },
    //下载配置文件
    download_profile(row) {
      // let formdata = new FormData();
      // formdata.append('account_number',localStorage.agent_number);
      // formdata.append('net_bar_id',row.net_bar_id);
      // formdata.append("net_bar_name",row.Name);
      let pa =
        "?account_number=" +
        localStorage.agent_number +
        "&net_bar_id=" +
        row.net_bar_id +
        "&net_bar_name=" +
        row.Name;
      sysApi.downloadby_profile(pa).then((res) => {
        window.location.href =
          "https://new-file.yebaojiasu.com/api/v1/new_file/bar_config?account_number=" +
          localStorage.agent_number +
          "&net_bar_id=" +
          row.net_bar_id +
          "&net_bar_name=" +
          row.Name;
      });
    },
    // 点击充值
    rechargeWay(value) {
      this.parmasRecharge.bar_count = value.count;
      this.parmasRecharge.cyberbar_id = null;
      this.parmasRecharge.month = 1;
      this.parmasRecharge.pay_way = "2";
      this.parmasRecharge.cyberbar_id = value.ID;
      this.paymentAmount = 0;
      this.recharge = true;
      this.rechargeDuration = "请选择";
    },
    // 充值取 消
    rechargeCancel() {
      // this.parmasRecharge.bar_count = 20;
      this.parmasRecharge.cyberbar_id = null;
      this.parmasRecharge.month = 1;
      (this.parmasRecharge.pay_way = "2"), (this.recharge = false);
      this.rechargeDuration = "请选择";
    },

    internetBarDialog(val) {
      console.log(val);

      this.ip_list = val.ip_list;
      this.net_bar_id = val.net_bar_id;
      let disStatus = val.ip_list.split(",");

      this.bar.ip_list1 = disStatus[0];
      this.bar.ip_list2 = disStatus[1];
      this.bar.ip_list3 = disStatus[2];
      this.internetBarDialogVisible = true;
    },
    // 网吧确定
    internetBarDialogCancel() {
      let { ip_list1, ip_list2, ip_list3 } = { ...this.bar };
      this.addBar(ip_list1, ip_list2, ip_list3);

      // 后端返回3个地址的时候
      // if (this.disStatus.length == 3) {
      //   return this.$message.error("ip地址已满");
      // }

      // 后端返回2个地址的时候
      // if (this.disStatus.length == 2) {
      //   if (ip_list3 == "") {
      //     return this.$message.error("请输入ip地址");
      //   } else {
      //     if (ip_list3.length > 7 && ip_list3.length < 20) {
      //       this.addBar(ip_list3);
      //     } else {
      //       return this.$message.error("请输入合法的ip地址");
      //     }
      //   }
      // }
      // 后端返回1个地址的时候
      // if (this.disStatus.length == 1) {
      //   if (ip_list2 != "" || ip_list3 != "") {
      //     if (ip_list3 == ip_list2) {
      //       return this.$message.error("ip地址不能相同");
      //     }
      //     if (
      //       (ip_list2.length > 10 && ip_list2.length < 20) ||
      //       (ip_list3.length > 10 && ip_list3.length < 20)
      //     ) {
      //       this.addBar(ip_list2, ip_list3);
      //     } else {
      //       return this.$message.error("请输入合法的ip地址");
      //     }
      //   } else {
      //     return this.$message.error("请输入ip地址");
      //   }
      // }

      // 后端返回0个地址的时候
      // if (this.disStatus.length == 0) {
      //   if (ip_list1 != "" || ip_list2 != "" || ip_list3 != "") {
      //     if (ip_list3 == ip_list2) {
      //       return this.$message.error("ip地址不能相同");
      //     }
      //     if (ip_list3 == ip_list1) {
      //       return this.$message.error("ip地址不能相同");
      //     }
      //     if (ip_list2 == ip_list1) {
      //       return this.$message.error("ip地址不能相同");
      //     }
      //     if (
      //       (ip_list1.length > 10 && ip_list1.length < 20) ||
      //       (ip_list2.length > 10 && ip_list2.length < 20) ||
      //       (ip_list3.length > 10 && ip_list3.length < 20)
      //     ) {
      //       this.addBar(ip_list1, ip_list2, ip_list3);
      //     } else {
      //       return this.$message.error("请输入合法的ip地址");
      //     }
      //   } else {
      //     return this.$message.error("请输入ip地址");
      //   }
      // }
    },

    // 公众方法添加ipp地址
    addBar(ip_list1 = "", ip_list2 = "", ip_list3 = "") {
      console.log(ip_list1, ip_list2, ip_list3);
      var ip_list_add = "";
      if (ip_list1.length >= 7) {
        ip_list_add += "," + ip_list1;
      }
      console.log(ip_list2, 11111);
      if (ip_list2.length >= 7) {
        ip_list_add += "," + ip_list2;
      }
      if (ip_list3.length >= 7) {
        ip_list_add += "," + ip_list3;
      }
      let aggregateIp = ip_list_add.replace(",", "");
      let params_ip_list = {
        ip_list: aggregateIp,
        net_bar_id: this.net_bar_id,
      };
      this.$http.post(this.$api.api.add_bar_ip, params_ip_list).then((res) => {
        if (res.data.code != 1) {
          return this.$message.error(res.data.result);
        }
        this.internetBarList();
        this.internetBarDialogVisible = false;
        this.bar.ip_list1 = "";
        this.bar.ip_list2 = "";
        this.bar.ip_list3 = "";
        return this.$message.success(res.data.result);
      });
    },

    // 网吧取消
    internetBarDialogRecharge() {
      this.internetBarDialogVisible = false;
      this.bar.ip_list1 = "";
      this.bar.ip_list2 = "";
      this.bar.ip_list3 = "";
    },
    delinternetBar(net_bar_id) {
      let delBar = {
        params: {
          net_bar_id: net_bar_id,
        },
      };
      this.$confirm("此操作将永久删除该网吧, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http.get(this.$api.api.delete_bar, delBar).then((res) => {
            if (res.data.code != 1) {
              return this.$message.error(res.data.result);
            }
            this.internetBarList();
            return this.$message.success(res.data.result);
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.content_box {
  .multiple {
    display: flex;

    .model_navigation {
      width: 240px;
      height: 79px;
      border: 1px solid #ebeef5;
      text-align: center;
      justify-content: center;
      align-items: center;
      display: flex;
      font-size: 14px;

      img {
        width: 38px;
        height: 38px;
      }

      .span1 {
        margin-right: 5px;
        margin-left: 5px;
      }

      .span2 {
        sup {
          font-size: 22px;
        }
      }
    }

    .model_navigation {
      border-left: 0;
    }

    .model_navigation:first-child {
      border-left: 1px solid #f1f6f9;
    }
  }

  .el_right_box {
    display: flex;
    // justify-content: space-between;
    align-items: center;
    // height: 80px;

    // background: red;
    .status {
      padding-right: 10px;
      padding-left: 10px;
      font-size: 12px;
    }

    .el_input_style {
      width: 200px;
    }

    .each_txt {

      // position: relative;
      .search_txt {
        padding: 0 10px;
        font-size: 12px;
      }
    }
  }

  .el-col-12 {
    width: 100%;
  }

  .el-dialog__body {
    padding-top: 0 !important;
    height: 468px !important;
  }

  .el_right_box1 {
    display: flex;

    // justify-content: center;
    // align-items: center;
    // height: 80px;
    // margin-top: 100px;
    // background: red;
    .status {
      padding-right: 10px;
      padding-left: 10px;
      font-size: 12px;
    }

    .el_input_style {
      width: 200px;
    }

    .each_txt {

      // position: relative;
      .search_txt {
        padding: 0 10px;
        font-size: 12px;
      }
    }
  }

  .table_conent {
    padding-top: 20px;

    .table_title {
      border: 1px solid #ebeef5;
      border-bottom: 0px;
      text-align: center;
      font-size: 18px;
      font-weight: bold;
      height: 49px;
      line-height: 49px;
      background: #f1f6f9;
    }

    .table_btn {
      // width: 80px !important;
    }
  }
}

.el-table {
  margin-top: 0px !important;
}

.tableBox {
  th {
    height: 30px;
    line-height: 30px;
  }
}

.tableBox {
  td {
    height: 30px;
    line-height: 30px;
  }
}

.pagetion {
  // display: flex;
  margin-bottom: 30px;
  text-align: right;
}

.el-pagination {
  padding: 0 !important;
}

.visible_conent {
  .visible_conent_price {
    position: relative;

    .price {
      text-align: center;
      display: inline-block;
      width: 100px;
      height: 38px;
      background: #f8fbff;
      border-left: 1px solid #dcdfe6;
      position: absolute;
      top: 1px;
      right: 4px;
    }
  }

  .visible_conent_minimum {
    position: relative;

    .minimum {
      text-align: center;
      display: inline-block;
      width: 100px;
      height: 38px;
      background: #f8fbff;
      border-left: 1px solid #dcdfe6;
      position: absolute;
      top: 1px;
      right: 4px;
    }

    .el_but {
      width: 100px;
      height: 38px;
      text-align: center;
      // display: inline-block;
      // width: 100px;
      // height: 38px;
      // background: #f8fbff;
      // border-left: 1px solid #dcdfe6;
      position: absolute;
      top: 1px;
      right: 1px;
    }
  }
}

.qrCodeBox {
  margin: 0 auto;
  background: #fff;
  width: 400px;
  height: 400px;
  text-align: center;

  .scanQecharge {
    font-size: 20px;
    font-weight: bold;
  }

  .amount {
    padding-top: 15px;
    color: #ff0000;
    font-size: 20px;
    font-weight: bold;
    padding-bottom: 10px;
  }

  .Recharge {
    color: #7e7e7e;
    font-size: 14px;
    padding-bottom: 10px;
  }

  #qrcodeImg {
    border: 1px solid #eee;
    padding: 20px;
  }

  .foorter {
    border-bottom: 2px solid #dbe4ee;
    margin: 20px;
  }

  .orderNumber {
    color: #8aa2c3;
    font-size: 14px;
  }
}

.timeOver {
  color: #ff0000;
  font-size: 20px;
  font-weight: bold;
  margin: 160px auto;
}

.search_box {
  display: inline-block;
  position: relative;
  width: 280px;

  .search {
    position: absolute;
    top: 5px;
    right: 8px;
    width: 53px;
    height: 30px;
    background: #409eff;
    text-align: center;
    justify-content: center;
    align-items: center;
    display: flex;
    border-radius: 6px;
    cursor: pointer;

    img {
      width: 15px;
      height: 18px;
    }
  }

  .positionl {
    margin-top: 30px;

    div {
      margin-top: 30px;

      span {
        margin-left: 30px;
        display: inline-block;
        border: 1px solid #fff;
        padding: 3px;
        font-size: 12px;
        cursor: pointer;
      }

      .span1 {
        margin-left: 30px;
        display: inline-block;
        border: 1px solid #409eff;
        color: #409eff;
        padding: 3px;
        font-size: 12px;
        cursor: pointer;
      }

      span:hover {
        margin-left: 30px;
        display: inline-block;
        border: 1px solid #409eff;
        color: #409eff;
        padding: 3px;
        font-size: 12px;
        cursor: pointer;
      }
    }
  }
}

.dialog-footer-right {
  text-align: right !important;
}

.moneryClass {
  margin-left: 50px;

  span {
    color: red;
  }
}

.el-form-item {
  margin-bottom: 20px !important;
}

.el-input__inner {
  width: 200px !important;
}
</style>
